import { render, staticRenderFns } from "./login_dingding_bind_account.vue?vue&type=template&id=c2f4e356&scoped=true"
import script from "./login_dingding_bind_account.vue?vue&type=script&lang=js"
export * from "./login_dingding_bind_account.vue?vue&type=script&lang=js"
import style0 from "./login_dingding_bind_account.vue?vue&type=style&index=0&id=c2f4e356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f4e356",
  null
  
)

export default component.exports